const apiUrl = {
  profile: 'profile',
  userList: 'user',
  userListForSelect: 'user/select',
  updateGraphUsers: 'update-graph-users',
  userRole: 'role',
  location: 'location',
  sublocation: 'sublocation',
  sublocations: 'sublocations',
  ownerInfo: 'ownerinfo',
  uiInfo: 'ui/menuRoles',
  countries: 'countries',
  states: 'states',
  cities: 'cities',
  owner: 'owners',
  locationType: 'types',
  areaTaxLocation: 'area-tax/locations',
  manageAreaTaxLocations: 'area-tax-locations',
  modem: 'modems',
  modemHistory: 'modem-history',
  model: 'models',
  modelCategory: 'model-categories',
  modelTheme: 'model-themes',
  modelManufacturer: 'model-manufacturers',
  machine: 'assets',
  machineType: 'asset-types',
  removeModemFromMachine: 'remove-modem-from-asset',
  machineStatus: 'asset-statuses',
  collections: 'collections',
  drafts: 'drafts',
  reconciliation: 'reconciliation',
  meters: 'meters',
  sublocationbyIR: 'sublocations-by-independent-rep',
  locationbyIR: 'locations-by-independent-rep',
  machineMeters: 'asset-meters',
  deposits: 'deposits',
  modelType: 'model-types',
  gameCategories: 'game-categories',
  currencies: 'currencies',
  locationOwnerTypes: 'owner-types',
  lease: 'contracts',
  rentOptions: 'rent-options',
  validateSubLocationsPeriod: 'validate-sublocations-period',
  exchangeRate: 'exchange-rate',
  currencyLayer: 'currency-layer',
  productCategories: 'product-categories',
  intercard: 'intercard',
  seedlive: 'seedlive',
  x3Departments: 'x3_departments',
  x3Industries: 'x3_industries',
  x3Owners: 'x3_owners',
  trackings: 'trackings',
  history: 'history',
  nayax: 'nayax',
  accountNumber: 'account-numbers',
  globalAccountNumber: 'global-account-numbers',
  vendors: 'vendors',
  accountSummaryNoesHistory: 'account-summary-notes-history',
  accountSummaryNotes: 'account-summary-notes',
  salesAssociate: 'sales-associates',
  creditCardFeeRate: 'user/rep-rate-fee',
  locationUserHistory: 'location-users-history',
  areaTaxHistory: 'area-tax-history',
  stateTaxHistory: 'state-tax-history',
  seedliveFileUpload: 'fileUpload',
  unmappedDataFeed: 'unmapped-data-feed',
  unmappedDataFeedSources: 'unmapped-data-feed/sources',
  missingDataFeedSources: 'missing-data-feed/sources',
  missingDataFeedJobTypes: 'missing-data-feed/job-types',
  missingDataFeed: 'missing-data-feed',
  glPostingsMonthly: 'gl-postings/monthly',
  glPostingsMonthlyFeeds: 'gl-postings/monthly/feeds',
  reconciliationSummary: 'gl-postings/monthly/reconciliation-summary',
  weeklyGLPosting: 'gl-postings/weekly',
};

export { apiUrl };
